module.exports = __webpack_public_path__ + "static/media/complete.bdcf543a.png";